import { FC, useState } from 'react'
import { Modal } from 'react-bootstrap'
import CloseButton from 'react-bootstrap/CloseButton';
import FAIcon from '../../../../../_metronic/helpers/components/FAIcon'
import { faApple, faGooglePlay } from '@fortawesome/free-brands-svg-icons'

const AcceptInviteDialog: FC<{
  showConfirmationDialog: boolean;
  groups: any;
  isFirstStepCompleted?: boolean;
  onCloseDialog?: () => void;
}> = ({ showConfirmationDialog, groups, isFirstStepCompleted, onCloseDialog }) => {
  const [isConfirmed, setIsConfirmed] = useState(isFirstStepCompleted)

  const handleConfirmData = () => {
    setIsConfirmed(true)
  }

  const handleLinkButton = (path: string) => {
    window.location.replace(path)
  }

  const isCompanyAdmin = groups.some((group: any) => group === 'Company Admins')
  const isSupervisorOrHS = groups.some((group: any) =>
    ['Supervisor', 'H&S Specialist'].includes(group)
  )

  return (
    <>
      {showConfirmationDialog && (
        <Modal show={showConfirmationDialog} tabIndex={0} centered>
          <Modal.Body>
            {Boolean(isFirstStepCompleted) && (
              <CloseButton
                onClick={() => onCloseDialog && onCloseDialog()}
                className='btn position-absolute p-1 accept-invite-dialog-close-btn' />
            )}
            <div className={`p-7 d-flex flex-column gap-6 accept-invite-dialog-scrollable ${Boolean(isFirstStepCompleted )? 'mt-5' : ''}`}>
              {isFirstStepCompleted ? (
                <video
                  className='exclamation align-self-center'
                  src='/media/exclamation.mp4'
                  autoPlay
                  loop
                  muted
                  playsInline
                  poster='/media/exclamation.gif'
                />
              ) : (
                <img
                  className='congratulations align-self-center'
                  src='/media/congratulations.gif'
                  alt='Congratulations'
                />
              )}
              <div className='d-flex gap-1 flex-column'>
                <div className='align-self-center congratulation-text'>
                  {isFirstStepCompleted ? 'Access Restricted' : 'Congratulations !'}
                </div>
                <div>
                  <div className='congratulation-sub-text align-self-center text-center'>
                    {isFirstStepCompleted
                      ? 'This portal is available to authorized admin users only.'
                      : 'Your Decent account is ready.'}
                    {isConfirmed && !isFirstStepCompleted &&
                      <div className='accept-invite-dialog-congratulation-sub-text'>
                        Choose how you'd like to continue.
                      </div>
                    }
                  </div>
                  <div className='congratulation-sub-text align-self-center text-center'>
                    {isFirstStepCompleted &&
                      'Please sign in through the Web App or Mobile App to continue.'}
                  </div>
                </div>
              </div>
              {isConfirmed ? (
                <div className='btn-align d-flex flex-column gap-3 w-100'>
                  {isCompanyAdmin && (
                    <div className='d-flex flex-column gap-2 w-100'>
                      <button
                        type='submit'
                        className='btn btn-primary btn-pill accept-invite-redirect-btn align-self-center link-btn w-100'
                        onClick={() => handleLinkButton(`${process.env.REACT_APP_URL}`)}
                      >
                        <div>
                          Continue on Admin Panel
                          <img
                            className='ms-3'
                            src='/media/icons/duotune/general/Arrow - Right.svg'
                            alt='->'
                          />
                        </div>
                        <div className='text-center accept-invite-web-app-description font-weight-regular text-light-gray'>
                          Access your admin dashboard
                        </div>
                      </button>
                    </div>
                  )}
                  {isSupervisorOrHS && (
                    <div className='d-flex flex-column gap-2 w-100'>
                      <button
                        type='submit'
                        className='btn btn-pill accept-invite-redirect-btn mobile-app-link-btn align-self-center link-btn w-100'
                        onClick={() => handleLinkButton(`${process.env.REACT_APP_API_FLUTTER_URL}`)}
                      >
                        <div>
                          Login to Web App
                          <img
                            className='ms-3'
                            src='/media/icons/duotune/general/blue-arrow.svg'
                            alt='->'
                          />
                        </div>
                        <div className='text-center accept-invite-web-app-description font-weight-regular'>
                          Secure access via your browser
                        </div>
                      </button>
                    </div>
                  )}
                  <div className='d-flex flex-column gap-2 accept-invite-mobile-section w-100'>
                    <div className='accept-invite-divider-with-text'>
                      <div className='accept-invite-divider-line'></div>
                      <span className='accept-invite-mobile-heading'>Continue on Mobile</span>
                      <div className='accept-invite-divider-line'></div>
                    </div>
                    <div className='text-center accept-invite-mobile-description'>
                      Scan, inspect, and report on the go
                    </div>
                    <div className='d-flex justify-content-center gap-2 accept-invite-badge-container w-100'>
                      <a
                        href={process.env.REACT_APP_ANDROID_URL}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='accept-invite-badge-link'
                      >
                        <span className='me-2 accept-invite-badge-icon'>
                          <FAIcon
                            icon={faGooglePlay as any}
                            defaultClassnameApply={false}
                          />
                        </span>
                        <div className='d-flex flex-column accept-invite-badge-text-container'>
                          <span className='accept-invite-badge-text-small'>GET IT ON</span>
                          <span className='accept-invite-badge-text-large'>Google Play</span>
                        </div>
                      </a>
                      <a
                        href={process.env.REACT_APP_IOS_URL}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='accept-invite-badge-link'
                      >
                        <span className='me-2 accept-invite-badge-icon'>
                          <FAIcon
                            icon={faApple as any}
                            defaultClassnameApply={false}
                          />
                        </span>
                        <div className='d-flex flex-column accept-invite-badge-text-container'>
                          <span className='accept-invite-badge-text-small'>Download on the</span>
                          <span className='accept-invite-badge-text-large'>App Store</span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              ) : (
                <button
                  type='submit'
                  className='btn btn-primary btn-pill dialog-done-btn submit-btn align-self-center'
                  onClick={handleConfirmData}
                >
                  Done
                  <img
                    className='ms-3'
                    src='/media/icons/duotune/general/Arrow - Right.svg'
                    alt='->'
                  />
                </button>
              )}
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  )
}

export { AcceptInviteDialog }
